
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("3JZ3w", function(module, exports) {

$parcel$export(module.exports, "ProfileComponent", () => $c7c3568d8f19408f$export$8b6285a9ee54832b);
/* ProfileComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $diswb = parcelRequire("diswb");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");
var $js7oX = parcelRequire("js7oX");

var $iPfZG = parcelRequire("iPfZG");

var $lnHWt = parcelRequire("lnHWt");

var $2W0qg = parcelRequire("2W0qg");

var $inPa6 = parcelRequire("inPa6");

var $5izcQ = parcelRequire("5izcQ");

var $kLRO8 = parcelRequire("kLRO8");
var $e8jGT = parcelRequire("e8jGT");

var $esRft = parcelRequire("esRft");

var $lGgRw = parcelRequire("lGgRw");

var $aIk0I = parcelRequire("aIk0I");

var $irVI7 = parcelRequire("irVI7");
var $fGzMp = parcelRequire("fGzMp");

var $dPJCf = parcelRequire("dPJCf");

var $41c4c = parcelRequire("41c4c");

var $foQ4a = parcelRequire("foQ4a");

var $jlIaF = parcelRequire("jlIaF");

var $dEBDF = parcelRequire("dEBDF");

var $1ytiN = parcelRequire("1ytiN");

var $jmjWc = parcelRequire("jmjWc");
var $luv00 = parcelRequire("luv00");

var $lBYCH = parcelRequire("lBYCH");

var $e4o8D = parcelRequire("e4o8D");

var $9wGTI = parcelRequire("9wGTI");

var $djivE = parcelRequire("djivE");
const $c7c3568d8f19408f$var$loginLink = typeof window !== 'undefined' ? `${0, $jlIaF.CONTEXT_PATH}/login.action?os_destination=${window.location.pathname.replace((0, $jlIaF.CONTEXT_PATH), '')}` : '';
const $c7c3568d8f19408f$var$i18n = (0, $2nPZH.defineMessages)({
    signIn: {
        id: "app-navigation.sign.in.tooltip",
        defaultMessage: "Sign In"
    },
    profile: {
        id: "app-navigation.profile.label",
        defaultMessage: "Your profile and preferences"
    },
    guestLozenge: {
        id: "app-navigation.profile.guest-lozenge",
        defaultMessage: "Guest"
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c7c3568d8f19408f$var$StyledContainer = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_c71l132o _syaz1fxt",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c7c3568d8f19408f$var$ProfilePlaceholder = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1bsb14no _4t3i14no",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c7c3568d8f19408f$var$ProfileContainer = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $c7c3568d8f19408f$var$GuestLozengeWrapper = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_2rko1l7b _bfhk11bn _kqswstnw _94n51b66",
            __cmplp.className
        ])
    });
});

const $c7c3568d8f19408f$var$ProfileMenuLoader = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "_Hft3",
    name: "ProfileMenuLoader",
    loader: async ()=>(await (parcelRequire("2Oxbn"))).ProfileMenu
});

const $c7c3568d8f19408f$var$Nav4OptOutSpotlightLoader = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "vx79z",
    name: "Nav4OptOutSpotlightLoader",
    loader: async ()=>(await (parcelRequire("iTDAb"))).Nav4OptOutSpotlight,
    loading: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, children)
});

const $c7c3568d8f19408f$var$Nav4OptOutSpotlightAfterPaintLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "GNCyw",
    name: "Nav4OptOutSpotlightAfterPaintLoader",
    loader: async ()=>(await (parcelRequire("iTDAb"))).Nav4OptOutSpotlight,
    loading: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, children)
});
const $c7c3568d8f19408f$var$MemoizedProfileComponent = /*#__PURE__*/ (0, $gwFzn.memo)(({ intl: intl, openDialog: openDialog, isOpen: isOpen, onClose: onCloseCallback, onClick: onClick })=>{
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const { profileMenuButtonRef: profileMenuButtonRef } = (0, $gwFzn.useContext)((0, $lBYCH.AppNavigationContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { data: data, loading: loading } = (0, $diswb.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
    (0, $djivE.AppNavigationUnifiedQuery));
    const { isAnonymous: isAnonymous, loading: contextLoading } = (0, $gwFzn.useContext)((0, $1ytiN.SPAViewContext));
    const { isExternalCollaborator: isExternalCollaborator } = (0, $foQ4a.useIsExternalCollaborator)();
    const onClose = (0, $gwFzn.useCallback)(()=>{
        (0, $fGzMp.getExperienceTracker)().abort({
            name: (0, $irVI7.APP_NAV_PROFILE_DROPDOWN_EXPERIENCE),
            reason: 'dropdown closed by user',
            attributes: {
                navVersion: '3'
            }
        });
        onCloseCallback();
    }, [
        onCloseCallback
    ]);
    const handleLoginClick = (0, $gwFzn.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'globalNavigation',
                action: 'clicked',
                actionSubject: 'navigationItem',
                actionSubjectId: 'login',
                attributes: {
                    selectedItemPageContext: routeDataRef.current?.routeName,
                    navigationLayer: 'global',
                    navVersion: '3',
                    navdexPointType: (0, $dEBDF.START_TOUCH)
                }
            }
        }).fire();
    }, [
        routeDataRef,
        createAnalyticsEvent
    ]);
    const handleProfileClick = (0, $gwFzn.useCallback)(()=>{
        onClick();
        if (isOpen) onClose();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'globalNavigation',
                action: 'clicked',
                actionSubject: 'navigationItem',
                actionSubjectId: 'profile',
                attributes: {
                    selectedItemPageContext: routeDataRef.current?.routeName,
                    navigationLayer: 'global',
                    navVersion: '3',
                    navdexPointType: (0, $dEBDF.START_TOUCH),
                    is_guest: isExternalCollaborator
                }
            }
        }).fire();
    }, [
        isOpen,
        onClose,
        onClick,
        routeDataRef,
        createAnalyticsEvent,
        isExternalCollaborator
    ]);
    const preloadMenu = (0, $gwFzn.useCallback)(()=>{
        (0, $41c4c.preloadProfileMenu)();
        $c7c3568d8f19408f$var$ProfileMenuLoader.preload();
    }, []);
    if (loading || contextLoading || renderServerPlaceholder && !(0, $9wGTI.fg)('confluence_frontend_ssr_avatar')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($c7c3568d8f19408f$var$ProfilePlaceholder, null);
    if (isAnonymous) return (0, $9wGTI.fg)('custom-interactive-elements-not-keyboard-focusable') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2W0qg.default), {
        backgroundColor: "color.background.neutral.subtle",
        testId: "app-navigation-login",
        onClick: handleLoginClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $e8jGT.SignIn), {
        tooltip: intl.formatMessage($c7c3568d8f19408f$var$i18n.signIn),
        href: $c7c3568d8f19408f$var$loginLink
    })) : // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions, @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("span", {
        "data-testid": "app-navigation-login",
        onClick: handleLoginClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $e8jGT.SignIn), {
        tooltip: intl.formatMessage($c7c3568d8f19408f$var$i18n.signIn),
        href: $c7c3568d8f19408f$var$loginLink
    }));
    else {
        const user = data?.user || {
            photos: [],
            displayName: null,
            id: null
        };
        const profileIconUrl = user?.photos?.[0]?.value;
        const profileTooltip = user.displayName ? user.displayName : null;
        const Icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($c7c3568d8f19408f$var$ProfileContainer, null, isExternalCollaborator ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $esRft.default), {
            src: profileIconUrl,
            size: "medium",
            testId: "profile-component-navigation"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($c7c3568d8f19408f$var$GuestLozengeWrapper, {
            "data-testid": "guest-lozenge-indicator"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $aIk0I.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $c7c3568d8f19408f$var$i18n.guestLozenge)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $esRft.default), {
            src: profileIconUrl,
            size: "small",
            testId: "profile-component-navigation"
        }));
        const ChosenNav4OptOutSpotlightLoader = (0, $9wGTI.fg)('confluence_frontend_ssr_avatar') ? $c7c3568d8f19408f$var$Nav4OptOutSpotlightAfterPaintLoader : $c7c3568d8f19408f$var$Nav4OptOutSpotlightLoader;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lGgRw.default), {
            isOpen: isOpen,
            onClose: onClose,
            offset: [
                14,
                0
            ],
            content: ({ update: scheduleUpdate })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($c7c3568d8f19408f$var$StyledContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($c7c3568d8f19408f$var$ProfileMenuLoader, {
                    onClose: onClose,
                    dialogFn: openDialog,
                    scheduleUpdate: scheduleUpdate
                })),
            trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("span", {
                    "data-testid": "app-navigation-profile",
                    "data-vc": "app-navigation-profile",
                    ...ssrPlaceholderIdProp
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(ChosenNav4OptOutSpotlightLoader, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5izcQ.default), {
                    name: "nav-profile"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kLRO8.Profile), {
                    ...triggerProps,
                    ref: profileMenuButtonRef ? (0, $lnHWt.mergeRefs)([
                        triggerProps.ref,
                        profileMenuButtonRef
                    ]) : triggerProps.ref,
                    icon: Icon,
                    onClick: handleProfileClick,
                    onFocus: preloadMenu,
                    onMouseEnter: preloadMenu,
                    tooltip: profileTooltip,
                    isSelected: isOpen,
                    "aria-label": intl.formatMessage($c7c3568d8f19408f$var$i18n.profile),
                    "aria-haspopup": true,
                    "aria-expanded": isOpen
                }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iPfZG.EngagementSpotlight), {
                    engagementId: "nav-profile"
                })),
            placement: "bottom",
            shouldRenderToParent: true
        });
    }
});
const $c7c3568d8f19408f$export$8b6285a9ee54832b = (0, $js7oX.default)($c7c3568d8f19408f$var$MemoizedProfileComponent);

});
parcelRegister("kLRO8", function(module, exports) {

$parcel$export(module.exports, "Profile", () => $a12fcbbfbeaca916$export$5120f2d0b8d4cab8);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $8MTIk = parcelRequire("8MTIk");
const $a12fcbbfbeaca916$export$5120f2d0b8d4cab8 = /*#__PURE__*/ (0, $gwFzn.forwardRef)((props, ref)=>{
    const { component: component, href: href, icon: icon, id: id, isDisabled: isDisabled, isSelected: isSelected, label: labelProp, onBlur: onBlur, onClick: onClick, onFocus: onFocus, onMouseDown: onMouseDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, target: target, testId: testId, theme: theme, tooltip: tooltip, ...rest } = props;
    const label = labelProp || (typeof tooltip === 'string' ? tooltip : 'Your profile and settings');
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        role: "listitem",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $8MTIk.IconButton), {
            component: component,
            href: href,
            icon: icon,
            id: id,
            isDisabled: isDisabled,
            isSelected: isSelected,
            label: label,
            onBlur: onBlur,
            onClick: onClick,
            onFocus: onFocus,
            onMouseDown: onMouseDown,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onMouseUp: onMouseUp,
            ref: ref,
            target: target,
            testId: testId,
            // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
            theme: theme,
            tooltip: tooltip,
            isTooltipAnnouncementDisabled: true,
            ...rest
        })
    });
});
var // This exists only to extract props.
// eslint-disable-next-line import/no-anonymous-default-export
$a12fcbbfbeaca916$export$2e2bcd8739ae039 = (props)=>{};

});

parcelRegister("e8jGT", function(module, exports) {

$parcel$export(module.exports, "SignIn", () => $d5b4be92833305ac$export$b64708c6f1b3ed96);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $gYFpk = parcelRequire("gYFpk");

var $8MTIk = parcelRequire("8MTIk");
const $d5b4be92833305ac$export$b64708c6f1b3ed96 = (props)=>{
    const { component: component, href: href, id: id, isDisabled: isDisabled, isSelected: isSelected, label: label, onBlur: onBlur, onClick: onClick, onFocus: onFocus, onMouseDown: onMouseDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, target: target, testId: testId, tooltip: tooltip, ...rest } = props;
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        role: "listitem",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $8MTIk.IconButton), {
            component: component,
            href: href,
            icon: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gYFpk))), {
                color: "currentColor",
                spacing: "spacious",
                label: typeof tooltip === 'string' ? tooltip : 'Sign-in Icon'
            }),
            id: id,
            isDisabled: isDisabled,
            isSelected: isSelected,
            label: label,
            onBlur: onBlur,
            onClick: onClick,
            onFocus: onFocus,
            onMouseDown: onMouseDown,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onMouseUp: onMouseUp,
            target: target,
            testId: testId,
            tooltip: tooltip,
            ...rest
        })
    });
};

});
parcelRegister("gYFpk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::80177156cdfd0c4ec20061b3615d4605>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c5c25e9fec556e9f$var$_react = $c5c25e9fec556e9f$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $c5c25e9fec556e9f$var$_logIn = $c5c25e9fec556e9f$var$_interopRequireDefault((parcelRequire("ilSNM")));

var $c5c25e9fec556e9f$var$_signIn = $c5c25e9fec556e9f$var$_interopRequireDefault((parcelRequire("iRXVy")));
function $c5c25e9fec556e9f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LogInIcon.
 * This component is LogInIcon, with `UNSAFE_fallbackIcon` set to "SignInIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for log in.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c5c25e9fec556e9f$var$LogInIcon = (props)=>/*#__PURE__*/ $c5c25e9fec556e9f$var$_react.default.createElement($c5c25e9fec556e9f$var$_logIn.default, Object.assign({
        LEGACY_fallbackIcon: $c5c25e9fec556e9f$var$_signIn.default
    }, props));
$c5c25e9fec556e9f$var$LogInIcon.Name = 'LogInIconMigration';
var $c5c25e9fec556e9f$var$_default = module.exports.default = $c5c25e9fec556e9f$var$LogInIcon;

});


parcelRegister("41c4c", function(module, exports) {

$parcel$export(module.exports, "preloadProfileMenu", () => $c0dbaa4ed1720915$export$5ca34e43e28ce619);

var $4vyfK = parcelRequire("4vyfK");
var $eSLr0 = parcelRequire("eSLr0");
const $c0dbaa4ed1720915$export$5ca34e43e28ce619 = ()=>Promise.all([
        (0, $4vyfK.preloadWebItemLocation)({
            location: (0, $eSLr0.SYSTEM_USER)
        })
    ]);

});

parcelRegister("2Oxbn", function(module, exports) {

let $20c9fd9fd0118ead$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $20c9fd9fd0118ead$var$load("7Q0UC"),
    $20c9fd9fd0118ead$var$load("6qah4"),
    $20c9fd9fd0118ead$var$load("4PQXU"),
    $20c9fd9fd0118ead$var$load("1epse"),
    $20c9fd9fd0118ead$var$load("5joXW"),
    $20c9fd9fd0118ead$var$load("c6MKV"),
    $20c9fd9fd0118ead$var$load("9IyPY")
]).then(()=>parcelRequire('1XrYH'));

});

parcelRegister("iTDAb", function(module, exports) {

let $dc1c1157ae6c525f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $dc1c1157ae6c525f$var$load("inzsN").then(()=>parcelRequire('1nwt7'));

});



//# sourceMappingURL=ProfileComponent.c698b617.js.map
